import { render, staticRenderFns } from "./BrAdminNotesList.vue?vue&type=template&id=7aaa84bc&scoped=true&"
import script from "./BrAdminNotesList.vue?vue&type=script&lang=js&"
export * from "./BrAdminNotesList.vue?vue&type=script&lang=js&"
import style0 from "./BrAdminNotesList.vue?vue&type=style&index=0&id=7aaa84bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aaa84bc",
  null
  
)

export default component.exports